export default {
  buttonText: "Subscribe"
};
